import { OPEN_MODAL, CLOSE_MODAL } from '../../actions/modalActions'

const initialState = {
  isOpen: false,
  content: null,
  closable: true,
}

const modalReducer = (state = initialState, action) => {
  if (Object.keys(state).length === 0) return initialState

  switch (action?.type) {
    case OPEN_MODAL:
      return {
        isOpen: true,
        content: action.payload,
        closable: action.closable ?? true,
      }
    case CLOSE_MODAL:
      return {
        ...initialState,
      }
    default:
      return state
  }
}

export default modalReducer
